import { datadogRum } from '@datadog/browser-rum'

const SERVICE_NAME = 'ucsnodeweb'
const APPLICATION_ID = {
  PRODUCTION: '269ef2e8-7c6a-4ee9-ad26-c39f0d5c47f4',
  SANDBOX: 'fcf03692-2698-47c0-87ee-dd2a15c6d978',
  QA: 'd7c5c11d-8864-4cb4-85ca-2b766c608481',
}
const CLIENT_ID = {
  PRODUCTION: 'pub6204a07118eb3ce24da552750f8f404f',
  SANDBOX: 'pub218e46aee6ce26cfd74bc3e16c26bf5d',
  QA: 'pub0dce81def3c4655a5b6860364a6c306a',
}

const DATADOG_RUM_SITE = 'us5.datadoghq.com'

/* istanbul ignore next */
function getClientEnvironment() {
  const hostname = typeof window !== 'undefined' ? window.location.host : ''
  if (hostname.includes('localhost')) return 'DEVELOPMENT'
  if (hostname.includes('qa.paypal.com')) return 'STAGE'
  if (hostname.includes('sandbox.paypal.com')) return 'SANDBOX'
  if (hostname.includes('paypal.com')) return 'PRODUCTION'

  return undefined
}

/* istanbul ignore next */
function getDDTraceLink(correlationId) {
  const environment = getClientEnvironment()
  switch (environment) {
    case 'PRODUCTION':
      return `https://go/ddprod/trace?${correlationId}`
    case 'SANDBOX':
      return `https://go/ddsb/trace?${correlationId}`
    default:
      return `https://go/ddqa/trace?${correlationId}`
  }
}

/* istanbul ignore next */
function getCalLogLink(correlationId) {
  const environment = getClientEnvironment()
  switch (environment) {
    case 'PRODUCTION':
      return `https://go/ddprod/tocal?${correlationId}`
    case 'SANDBOX':
      return `https://go/ddsb/tocal?${correlationId}`
    default:
      return `https://go/ddqa/tocal?${correlationId}`
  }
}

/* istanbul ignore next */
function getApplicationId() {
  const environment = getClientEnvironment()
  switch (environment) {
    case 'PRODUCTION':
      return APPLICATION_ID.PRODUCTION
    case 'SANDBOX':
      return APPLICATION_ID.SANDBOX
    default:
      return APPLICATION_ID.QA
  }
}

/* istanbul ignore next */
function getClientToken() {
  const environment = getClientEnvironment()
  switch (environment) {
    case 'PRODUCTION':
      return CLIENT_ID.PRODUCTION
    case 'SANDBOX':
      return CLIENT_ID.SANDBOX
    default:
      return CLIENT_ID.QA
  }
}

/* istanbul ignore next */
function addCorrelationIdToContext(event, correlationId) {
  if (correlationId && typeof correlationId === 'string') {
    event.context.correlationId = correlationId

    const ddTraceLink = getDDTraceLink(correlationId)
    const calLogLink = getCalLogLink(correlationId)
    event.context['dd-trace-url'] = ddTraceLink
    event.context['external-cal-url'] = calLogLink
  }
}

/* istanbul ignore next */
if (typeof window !== 'undefined') {
  // init Datadog RUM
  /* istanbul ignore next */
  datadogRum.init({
    // properties for idntifying and authenticating the application with RUM
    applicationId: getApplicationId(),
    clientToken: getClientToken(),
    site: DATADOG_RUM_SITE,
    service: SERVICE_NAME,
    env: process.env.NODE_ENV,
    // sampling must be set at 100 for session and 0 for recording. retention will be controlled on the backend in Datadog
    sessionSampleRate: 100,
    sessionReplaySampleRate: 0,
    // auto-instrumentations
    trackUserInteractions: true,
    trackResources: true,
    trackLongTasks: true,
    // privacy defaults to prevent leaking PII
    defaultPrivacyLevel: 'mask',
    enablePrivacyForActionName: true,
    // exclude log, tealeaf, and fpti endpoints which are not tied to user interactions from activity tracking
    excludedActivityUrls: [/log/i, /fpti/i, /tealeaf/i, /tracking\/ts/i],
    // exclude log, tealeaf, and fpti endpoints which are not tied to user interactions from universal tracing
    allowedTracingUrls: [
      (url) =>
        !(
          url.toLowerCase().includes('log') ||
          url.toLowerCase().includes('fpti') ||
          url.toLowerCase().includes('tealeaftarget') ||
          url.toLowerCase().includes('tracking/ts')
        ),
    ],
    beforeSend(event, context) {
      // modify RUM events to include the correlationId and links to logs and traces
      // for the request because we don't yet have universal tracing
      if (event.type === 'resource') {
        // handle fetch
        if ('response' in context && context?.response && context?.response?.headers) {
          const correlationId = context.response.headers.get('Paypal-Debug-Id')
          addCorrelationIdToContext(event, correlationId)
        }
        // handle XHR
        if (
          'xhr' in context &&
          context.xhr &&
          'getResponseHeader' in context.xhr &&
          typeof context.xhr.getResponseHeader === 'function'
        ) {
          const correlationId = context.xhr.getResponseHeader('Paypal-Debug-Id')
          addCorrelationIdToContext(event, correlationId)
        }
      }
      return true
    },
  })
}
